import { MainFooter } from '@/components/Footer';
import { Header } from '@/components/Header';
import { Box, Container } from '@chakra-ui/react';

interface IMyAccountLayout {
  children: React.ReactNode;
}

export const PlainLayout: React.FC<IMyAccountLayout> = ({ children }): JSX.Element => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Box as="footer" bg="white" py={12}>
        <Container maxW="8xl">
          <MainFooter />
        </Container>
      </Box>
    </>
  );
};
